import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../Components/Form";
import { Dispatch, SetStateAction } from "react";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    AtualizarPontoDeVendaController,
    CadastrarPontoDeVendaController,
} from "../../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";
import { IGestaoDeVisitasPonto } from "../../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import { ListarProdutosInteresseVendasController } from "../../../../Controllers/Vendas/Produtos/ProdutosController";
import moment from "moment";
import Swal from "sweetalert2";

interface ICadastrarEditarPontoVendaProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    row?: IGestaoDeVisitasPonto;
    ListarPontosDeVenda: (...args: any[]) => Promise<IGestaoDeVisitasPonto[]>;
}

export default function CadastrarEditarPontoVenda({
    setShow,
    row,
    ListarPontosDeVenda,
}: ICadastrarEditarPontoVendaProps) {
    const {
        execute: CadastrarPontoDeVenda,
        loading: CadastrarPontoDeVendaLoading,
    } = useAsyncCallback(CadastrarPontoDeVendaController);

    const {
        execute: AtualizarPontoDeVenda,
        loading: AtualizarPontoDeVendaLoading,
    } = useAsyncCallback(AtualizarPontoDeVendaController);

    function handleSubmit(formData: IGestaoDeVisitasPonto) {
        const horaInicial = moment(formData.NR_HORA_INICIAL, "HH:mm");
        const horaFinal = moment(formData.NR_HORA_FINAL, "HH:mm");

        if (horaInicial.isAfter(horaFinal)) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "A hora inicial não pode ser superior à hora final",
            });
            return;
        }

        if (row) {
            AtualizarPontoDeVenda({
                ...formData,
                ID_PONTO_VENDA: row.ID_PONTO_VENDA,
            }).then(() => {
                ListarPontosDeVenda();
                setShow(false);
            });
        } else {
            CadastrarPontoDeVenda({
                ...formData,
            }).then(() => {
                ListarPontosDeVenda();
                setShow(false);
            });
        }
    }

    const { execute: ListarProdutosInteresseVendas } = useAsyncCallback(
        () => ListarProdutosInteresseVendasController(0),
        []
    );

    return (
        <div className="container mx-auto p-4">
            <UnForm handleSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="mb-2">Descrição:</label>
                    <UnForm.Input
                        name="DS_PONTO_VENDA"
                        type="text"
                        maxLength={80}
                        className="border p-2 w-full"
                        required
                        defaultValue={row?.DS_PONTO_VENDA}
                    />
                </div>

                <div className="mb-4">
                    <label className="mb-2">Empreendimento:</label>
                    <UnForm.LazySelect
                        name="ID_PRODUTO"
                        className="border p-2 w-full"
                        required
                        controller={ListarProdutosInteresseVendas}
                        getKeyValue={(item) => item.ID_PRODUTO}
                        getDS={(item) => item.DS_PRODUTO}
                        defaultValue={row?.ID_PRODUTO}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>

                <div className="row">
                    <div className="col-md-6 mb-4">
                        <label className="mb-2">Hora Inicial:</label>
                        <UnForm.Input
                            name="NR_HORA_INICIAL"
                            type="time"
                            className="border p-2"
                            required
                            defaultValue={
                                row?.NR_HORA_INICIAL
                                    ? moment(
                                          row.NR_HORA_INICIAL,
                                          "HH:mm:ss"
                                      ).format("HH:mm")
                                    : undefined
                            }
                        />
                    </div>

                    <div className="col-md-6 mb-4">
                        <label className="mb-2">Hora Final:</label>
                        <UnForm.Input
                            name="NR_HORA_FINAL"
                            type="time"
                            className="border p-2"
                            required
                            defaultValue={
                                row?.NR_HORA_FINAL
                                    ? moment(
                                          row.NR_HORA_FINAL,
                                          "HH:mm:ss"
                                      ).format("HH:mm")
                                    : undefined
                            }
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <label className="mb-2">Intervalo (minutos):</label>
                    <UnForm.Input
                        type="number"
                        min={30}
                        max={360}
                        name="NR_INTERVALO"
                        className="border p-2"
                        required
                        defaultValue={row?.NR_INTERVALO}
                    />
                </div>

                <div className="d-flex justify-content-end">
                    <UnForm.SubmitButton
                        type="submit"
                        color={row ? "primary" : "success"}
                        icon={row ? faEdit : faPlus}
                        iconSize="sm"
                        loading={
                            CadastrarPontoDeVendaLoading ||
                            AtualizarPontoDeVendaLoading
                        }
                        disabled={
                            CadastrarPontoDeVendaLoading ||
                            AtualizarPontoDeVendaLoading
                        }
                        loadingSize="sm"
                        wrapperClassName="m-0"
                    >
                        {row ? "Editar" : "Cadastrar"}
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </div>
    );
}
